import React from 'react';
import { observer } from 'mobx-react-lite';
import TruckIcon from 'ati-ui-react/components/icons/Truck';
import Button from 'ati-ui-react/components/Button';

import { useStores } from 'hooks/useStores';
import { NoAdsMessageStyles } from './NoAdsMessageStyles';

const NoAdsMessage = observer(() => {
  const {
    errorsStore: { errorText },
  } = useStores();

  if (errorText === 'serverInTrouble') {
    return (
      <NoAdsMessageStyles>
        <TruckIcon />
        <span className="text">
          Сервис недоступен. Перезагрузите, пожалуйста, страницу или зайдите позже.
        </span>
        <div>
          <Button onClick={() => window.location.reload()}>Перезагрузить страницу</Button>
        </div>
      </NoAdsMessageStyles>
    );
  }

  return (
    <NoAdsMessageStyles>
      <TruckIcon />
      <span className="text">Объявления не найдены</span>
    </NoAdsMessageStyles>
  );
});

export default NoAdsMessage;
